import { OBJECTIVE_RELATION_TYPES } from './const';
import { differenceInCalendarDays } from 'date-fns';

export const groupRelatedObjectives = ({ objective, objectiveRelations }) => {
  return objectiveRelations ? objectiveRelations.reduce((acc, { type, ...objectiveRelation }) => {
    const title = type === OBJECTIVE_RELATION_TYPES.HIERARCHICAL ?
      `${type}-${
        objective.id === objectiveRelation.parent_id ?
          'children' :
          'parents'
      }` :
      type;

    const addNewGroup = (acc, title, objectiveRelation) => [
      ...acc,
      { title, objectiveRelations: [ objectiveRelation ] }
    ];

    const addRelationToExistingGroupOfSameTitle = (acc, title, objectiveRelation) =>
      acc.map(group => group.title === title ?
        {
          title,
          objectiveRelations: [
            ...group.objectiveRelations,
            objectiveRelation
          ]
        } :
        group);

    return !acc.some(group => group.title === title) ?
      addNewGroup(acc, title, objectiveRelation) :
      addRelationToExistingGroupOfSameTitle(acc, title, objectiveRelation);
  }, []) : [];
};

export const calculateKPIProgress = kpi =>
  kpi.entries.reduce((acc, entry) => acc + entry.value, 0) / Number(kpi.goalValue) * 100;

export const calculateKPIProrate = kpi => {
  const deadline = new Date(kpi.deadline);
  const daysFromNow = differenceInCalendarDays(deadline, new Date());

  if (daysFromNow < 0) {
    return 100;
  }

  const daysFromCreation = differenceInCalendarDays(deadline, new Date(kpi.created_at));

  return ((daysFromCreation - daysFromNow) / daysFromCreation) * 100;
};
